import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import StaffTranslationCreateForm from '../forms/StaffTranslationCreateForm';
import {fetchStaffMember, createStaffTranslation} from '../thunks';
import {fetchSites} from '../../sites/thunks';

class StaffTranslationCreate extends Component {
    componentWillMount() {
        this.props.fetchSites();
        this.props.fetchStaffMember(this.props.match.params.staffId);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleCreateStaffTranslationSubmit(formProps) {
        this.props.createStaffTranslation(
            formProps,
            this.props.match.params.staffId
        );
    }

    getSiteName(options) {
        let siteId = parseInt(this.props.match.params.siteId, 10);
        let name = options.find((element) => element.id === siteId);

        return name ? name.display_name : '';
    }

    render() {
        return (
            this.props.loading !== true && (
                <StaffTranslationCreateForm
                    staffMember={this.props.staffMember}
                    siteName={this.getSiteName(this.props.sites)}
                    handleFormSubmit={this.handleCreateStaffTranslationSubmit.bind(
                        this
                    )}
                    classes={this.props.classes}
                    loading={this.props.loading}
                    initialValues={this.props.initialValues}
                />
            )
        );
    }
}

const mapStateToProps = (state, props) => ({
    initialValues: {
        siteId: parseInt(props.match.params.siteId, 10),
        title_id: state.staff.staffMember.title_id,
    },
    staffMember: state.staff.staffMember,
    sites: state.sites.all,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(
    mapStateToProps,
    {
        fetchStaffMember,
        fetchSites,
        createStaffTranslation,
    }
)(withStyles(styles)(StaffTranslationCreate));



// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationCreate.jsx